module.exports = __webpack_public_path__ + "img/key 1.316d3353.png";